import getStore from 'Util/Store';

/**
 * Pure dataLayer push for GA4 ecommerce events. Always clears the previous
 * `ecommerce` object first, per GA4's own recommendation, so array/object
 * fields from one event don't leak into the next one pushed on the same
 * page.
 *
 * Usable from anywhere — plain class methods/dispatchers as well as React
 * components. Components should prefer `hooks/useGA4Ecommerce`, which wraps
 * this in a stable callback.
 *
 * @namespace Bodypwa/Util/GA4Ecommerce/Index/pushGA4EcommerceEvent
 */
export const pushGA4EcommerceEvent = (name, ecommerce = {}, dataLayerName = 'dataLayer') => {
    if (!name || typeof window === 'undefined') {
        return;
    }

    if (!window[dataLayerName]) {
        window[dataLayerName] = [];
    }

    window[dataLayerName].push({ ecommerce: null });
    window[dataLayerName].push({ event: name, ecommerce });
};

/**
 * One-shot (non-reactive) read of the backend config.events[eventName]
 * toggle, for call sites that can't use hooks (class components, plain
 * dispatchers). Components should prefer `hooks/useGtmEventEnabled`, which
 * stays in sync via useSelector if the config arrives after mount.
 *
 * @namespace Bodypwa/Util/GA4Ecommerce/Index/isGtmEventEnabled
 */
export const isGtmEventEnabled = (eventName) => Boolean(
    getStore().getState().GoogleTagManagerReducer?.config?.events?.[eventName]
);

/** @namespace Bodypwa/Util/GA4Ecommerce/Index/getCurrentCurrencyCode */
export const getCurrentCurrencyCode = () => getStore()
    .getState().ConfigReducer?.currencyData?.current_currency_code;
